import React from 'react';
import './extra-text.css';

const Footer = (props) => {
  return <section className="extra footer">
    <svg
      className="logo"
      id="header-logo-small"
      preserveAspectRatio="xMidYMid meet"
      width="426px"
      height="426px"
      viewBox="0 0 426 426"
    >
      <g
        id="header-logo-small-group"
        transform="translate(0.000000, 84.000000)"
      >
        <rect
          id="header-logo-small-red"
          transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) "
          x="205.693434"
          y="37.6934342"
          width="182"
          height="182"
        />
        <rect
          id="header-logo-small-green"
          transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) "
          x="38"
          y="38"
          width="182"
          height="182"
        />
      </g>
    </svg>
    <h1>Faccia a faccia<br/>con le elezioni</h1>
    </section>
}

export default Footer;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/Footer.js